import { useEffect } from "react";
import { useUnreadCount } from "../hooks/useUnreadCount";

const PREFIX = /^\(\d+\+?\)\s/;

/**
 * «(3) TURAQ.KG — …» in the browser tab while there are unread messages.
 * Pages set their own titles (useDocumentMeta), so the prefix is re-applied
 * whenever the title changes.
 */
export function UnreadTitle() {
  const unread = useUnreadCount();

  useEffect(() => {
    const apply = () => {
      const base = document.title.replace(PREFIX, "");
      const next = unread > 0 ? `(${unread > 99 ? "99+" : unread}) ${base}` : base;
      if (document.title !== next) document.title = next;
    };
    apply();
    const titleEl = document.querySelector("title");
    if (!titleEl) return;
    const observer = new MutationObserver(apply);
    observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
    return () => {
      observer.disconnect();
      document.title = document.title.replace(PREFIX, "");
    };
  }, [unread]);

  return null;
}
